// TODO: can this be removed? where is it used?
export const IN = "_~IN~_"
